<template>
  <div class="content thank-you">
    <div class="row row-center">
      <div class="column column-offset-25 column-50 mobile-full">
        <p><strong class="title">Terms of Service</strong></p>
        <p>
          Congratulations! You have just legally bound yourself to the following
          terms and conditions. No take-backsies.
        </p>

        <p>
          <strong>Section 1: Basic Acknowledgments</strong> You confirm that you
          are a real human being and not the Central Texas Regional Mobility
          Authority, who have been trying — and failing — to collect on my
          unpaid tolls for the past 6 years.
        </p>
        <p>
          <strong>Section 2: Keep Austin Moderately-Crowded</strong> You
          solemnly swear that you will not relocate to Austin, even if your
          employer offers you a life-changing sum of money to do so. I hear
          Richmond, Virginia is nice.
        </p>
        <p>
          <strong>Section 3: Cultural Benchmarks</strong> You acknowledge that
          <i>Kyrie</i> and <i>The Promise</i> are the greatest songs to come out
          of the 80s, and that the 70s perfected music as a whole.
        </p>
        <p>
          <strong>Section 4: Secret Names</strong> You also acknowledge that the
          use of a middle name is an antiquated practice and that we should
          henceforce refer to them as Secret Names, which is much cooler.
        </p>
        <p>
          <strong>Section 5: The Future</strong> You promise to have a good rest
          of your day.
        </p>
        <p class="footer">
          Effective Date: The heat death of the universe, or August 25th, 2049 —
          whichever comes first.
        </p>
        <router-link to="/">
          <button>&laquo; Back to work</button>
        </router-link>
      </div>
    </div>

    <div class="video-container">
      <video autoplay loop muted playsinline>
        <source src="/videos/Abstract_Pearl.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<style scoped lang="scss">
.thank-you {
  position: relative;
  overflow: hidden;
  color: black;
  height: calc(100vh - 5rem);
  display: flex;
  strong {
    font-weight: 600;
    &.title {
      text-transform: uppercase;
    }
  }

  @media (max-width: 40rem) {
    padding: 1rem 3rem;
    height: 100%;
  }
  .footer {
    border-top: 1px solid black;
    padding-top: 1rem;
    font-size: 1.25rem;
    font-family: "Departure Mono", monospace;
    text-transform: uppercase;
  }
}
.video-container {
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100vh - 5rem);
  width: 100%;
  z-index: -1;
}
</style>
